"use client";
import React, { useState } from 'react';
import styles from './AboutTokenSection.module.scss';
import Image from 'next/image';

interface AboutTokenSectionProps {
  name: string;
  symbol: string;
  description?: string;
  links: {
    website?: string;
    twitter?: string;
    discord?: string;
    telegram?: string;
  };
  contractAddress: string;
  status?: boolean;
}

const SOCIALS = [
  { key: 'website', label: 'Website', icon: '/tkn_lnd_pg_assets/images/icons/icon_website_globe.svg',urlPrefix: '' },
  { key: 'twitter', label: 'X', icon: '/tkn_lnd_pg_assets/images/icons/x-twitter.svg', urlPrefix: 'https://x.com/' },
  { key: 'discord', label: 'Discord', icon: '/tkn_lnd_pg_assets/images/icons/discord.svg' },
  { key: 'telegram', label: 'Telegram', icon: '/tkn_lnd_pg_assets/images/icons/telegram.svg', urlPrefix: 'https://t.me/' },
];

const AboutTokenSection: React.FC<AboutTokenSectionProps> = ({ name, symbol, description, links, contractAddress, status }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(contractAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  return (
    <div className={styles.aboutBox}>
      <h3 className={styles.aboutTitle}>About {name} {symbol && <span>{symbol}</span>}</h3>
      {description && <p className={styles.aboutDescription}>{description}</p>}
      <div className={styles.socialLinksRow}>
        {SOCIALS.map(social =>
          links[social.key as keyof typeof links] ? (
            <a
              key={social.key}
              href={(social.urlPrefix || '') + links[social.key as keyof typeof links]}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className={styles.socialLinkCard}
            >
              <Image src={social.icon} alt={`${social.label} icon`} width={20} height={20} />
              {social.label}
            </a>
          ) : null
        )}
      </div>
      <div className={styles.contractRow}>
        <div className={styles.contractCard}>
          <div className={styles.contractTitle}>Contract Address</div>
          <div className={styles.contractValueRow}>
            <span className={styles.contractAddress}>{contractAddress}</span>
            <button className={styles.copyBtn} onClick={handleCopy} title="Copy address">
              <Image src="/tkn_lnd_pg_assets/images/icons/icon_copy_text.svg" alt="Copy" width={18} height={18} />
              {copied && (
                <div className={styles.copiedMsgAbsolute}>Copied!</div>
              )}
            </button>
          </div>
        </div>
        <div className={styles.tickerCard}>
          <div className={styles.contractTitle}>Ticker</div>
          <div className={styles.contractValueRow}>
            {symbol}
          </div>
        </div>
        <div className={styles.tickerCard}>
          <div className={styles.contractTitle}>Status</div>
          <div className={styles.contractValueRow}>
            {status === true ? 'Verified' : 'Not verified'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTokenSection;
